import React from 'react';
import { Skeleton } from 'antd';
import { useTranslations } from 'next-intl';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useAppDispatch } from 'store';

import { setCategoryIds, setType, useCategoryCourses } from 'modules/courses';
import { globalConst, isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import CourseCard from '../course-card';
import CourseSkeleton from '../course-skeleton';
import SectionWrapper from '../section-wrapper';

const CategoryCourses = () => {
  const t = useTranslations();
  const { categoryCourses, isLoading } = useCategoryCourses();
  const dispatch = useAppDispatch();

  const onChangeType = (id?: number) => () => {
    if (!id) return;
    dispatch(setType('courses'));
    dispatch(setCategoryIds([id]));
  };

  return (
    <Visible
      if={isLoading}
      else={
        <Visible
          if={isEmptyArr(categoryCourses)}
          else={categoryCourses?.map(course => (
            <SectionWrapper
              onChange={onChangeType(course?.id)}
              key={course?.category_name}
              title={course?.category_name}
              path={globalConst.pageNames.COURSES_FILTER}
            >
              <Swiper className="md:!hidden" slidesPerView="auto" modules={[FreeMode]} freeMode spaceBetween={9}>
                {course?.courses?.map(course => (
                  <SwiperSlide key={course?.id} className="min-w-63 max-w-63">
                    <CourseCard course={course} />
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="hidden gap-3 md:grid md:grid-cols-3 lg:grid-cols-4">
                {course?.courses?.map(course => <CourseCard key={course?.id} course={course} />)}
              </div>
            </SectionWrapper>
          ))}
        >
          <EmptyData title={t('malumot_topilmadi')} />
        </Visible>
      }
    >
      <div className="mt-8">
        <div className="flex items-center justify-between">
          <Skeleton.Node className="!w-50 !h-4 !rounded-md" />
          <Skeleton.Node className="!w-30 !h-4 !rounded-md" />
        </div>
        <div className="mt-5 grid grid-cols-4 gap-3">
          {Array.from({ length: 8 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <CourseSkeleton key={index} />
          ))}
        </div>
      </div>
    </Visible>
  );
};

export default CategoryCourses;
